import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

const RedirectToPolicySettingsPage = () => {
  const { navigation } = useNavigation()

  const { settingId } = useStrictParams<'settingId'>()

  const to = navigation.settings.time_tracking.settingId.tabId.fullPath({
    settingId,
    tabId: 'edit',
  })

  return <Navigate to={to} />
}

export default RedirectToPolicySettingsPage
